import axios from '@/utils/request'
//考场查询
export function exam(data) {
    return axios({
        url: '/public_query/exam',
        method: 'post',
        data
    })
}